import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  API_BASE_URL,
  GET_SUPPLIER_DETAILS,
} from "../../../Config";
import Axios from "axios";

const SupplierViewModal = ({ supplierObj }) => {

  useEffect(() => {
    console.log(supplierObj, 'supplierObjsupplierObjsupplierObj')
  }, [supplierObj]);

  const [userDataSession, setUserDataSession] = useState([]);
  const [supplierDetails, setSupplierDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  // #region Session for userdetails
  useEffect(() => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      setUserDataSession(userData);
    } else {
      console.log("User data not found in sessionStorage", loading);
    }
  }, []);

  useEffect(() => {
    if (userDataSession && userDataSession.OrgId && supplierObj.Id) {
      setLoading(true);
      const url = `${API_BASE_URL}${GET_SUPPLIER_DETAILS}?OrgId=${userDataSession.OrgId}&SupplierId=${supplierObj.Id}`;
      Axios.get(url)
        .then((response) => {
          // console.log(response.data.ResultData[0], "aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa");
          if (response.data) {
            setSupplierDetails(response.data.ResultData[0]);
            setLoading(false);
          } else {
            console.error("Error fetching data:", response.data.Message);
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
        });
    }
  }, [userDataSession, supplierObj.Id]);

  return (
    <div>
      {/* View Supplier */}
      <div className="modal fade" id="view-supplier">
        <div
          className="modal-dialog modal-dialog-centered custom-modal-two mt-5"
          style={{ maxWidth: "70%" }}
        >
          <div className="modal-content">
            <div className="page-wrapper-new p-0">
              <div className="content">
                <div className="modal-header border-0 custom-modal-header">
                  <div className="page-title">
                    <h4>View Supplier</h4>
                  </div>
                  <button
                    type="button"
                    className="close d-flex ms-auto"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div
                  className="modal-body custom-modal-body"
                  style={{ height: "520px" }}
                >
                  <ul
                    className="nav nav-tabs tab-style-2 nav-justified mb-3 d-sm-flex d-block"
                    id="myTab1"
                    role="tablist"
                  >
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active"
                        id="order-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#order-tab-pane-view"
                        type="button"
                        role="tab"
                        aria-controls="home-tab-pane"
                        aria-selected="true"
                      >
                        <i className="fa-regular fa-address-book me-1 align-middle"></i>
                        Personal Info
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="confirmed-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#confirm-tab-pane-view"
                        type="button"
                        role="tab"
                        aria-controls="profile-tab-pane"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-building-columns me-1 align-middle"></i>
                        Bank Details
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link"
                        id="shipped-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#shipped-tab-pane-view"
                        type="button"
                        role="tab"
                        aria-controls="contact-tab-pane"
                        aria-selected="false"
                      >
                        <i className="fa-solid fa-house-user me-1 align-middle"></i>
                        Address
                      </button>
                    </li>
                  </ul>
                  <form>
                    <div className="tab-content" id="myTabContent">
                      <div
                        className="tab-pane fade show active text-muted "
                        id="order-tab-pane-view"
                        role="tabpanel"
                        aria-labelledby="home-tab-1"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Supplier Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.SupplierName"
                                value={supplierDetails.SupplierName || ""}
                                placeholder="Organization name"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Email</label>
                              <input
                                type="email"
                                className="form-control"
                                name="Supplier.EmailId"
                                value={supplierDetails.EmailId || ""}
                                placeholder="Enter email"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Phone</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.PhoneNo"
                                value={supplierDetails.PhoneNo || ""}
                                placeholder="Enter phone no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Contact Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.ContactName"
                                value={supplierDetails.ContactName || ""}
                                placeholder="Enter contact name"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Alternate Phone No</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Supplier.AlternatePhoneNo"
                                value={supplierDetails.AlternatePhoneNo || ""}
                                placeholder="Enter alternate no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Reg No</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.RegistrationNo"
                                value={supplierDetails.RegistrationNo || ""}
                                placeholder="Enter registration no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Payterm</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Supplier.PayTermDays"
                                value={supplierDetails.PayTermDays || ""}
                                placeholder="Enter payterm"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>GSTIN</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.GSTIN"
                                value={supplierDetails.GSTIN || ""}
                                placeholder="Enter GST no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Website</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.Website"
                                value={supplierDetails.Website || ""}
                                placeholder="Enter GST no"
                              />
                            </div>
                          </div>
                          <div className="col-lg-12">
                            <div className="input-blocks">
                              <label>Description</label>
                              <textarea
                                type="text"
                                className="form-control"
                                name="Supplier.Notes"
                                value={supplierDetails.Notes || ""}
                                placeholder="Enter notes..."
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade text-muted"
                        id="confirm-tab-pane-view"
                        role="tabpanel"
                        aria-labelledby="profile-tab-2"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Name</label>
                              <input
                                type="text"
                                className="form-control"
                                name="bank.BankName"
                                value={supplierDetails.BankName || ""}
                                placeholder="Enter bank name"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Account No</label>
                              <input
                                type="text"
                                className="form-control"
                                name="bank.AccountNumber"
                                value={supplierDetails.AccountNumber || ""}
                                placeholder="Enter account number"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>IFSC Code</label>
                              <input
                                type="text"
                                className="form-control"
                                name="bank.IFSCCode"
                                value={supplierDetails.IFSCCode || ""}
                                placeholder="Enter IFSC code"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Account Type</label>
                              <input
                                type="text"
                                className="form-control"
                                value={supplierDetails.AccountType || ""}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="tab-pane fade text-muted"
                        id="shipped-tab-pane-view"
                        role="tabpanel"
                        aria-labelledby="contact-tab"
                        tabIndex={0}
                      >
                        <div className="row">
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>Country</label>
                              <input
                                type="text"
                                className="form-control"
                                value="India"
                                style={{ cursor: "not-allowed" }}
                                readOnly
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>City</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.City"
                                value={supplierDetails.City || ""}
                                placeholder="Enter city"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4 col-sm-10 col-10">
                            <div className="input-blocks">
                              <label>State</label>
                              <input
                                type="text"
                                className="form-control"
                                name="Supplier.State"
                                value={supplierDetails.State || ""}
                                placeholder="Enter state"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>ZipCode</label>
                              <input
                                type="number"
                                className="form-control"
                                name="Supplier.ZIPCode"
                                value={supplierDetails.ZIPCode || ""}
                                placeholder="Enter pipncode"
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <div className="input-blocks">
                              <label>Address Type</label>
                              <input
                                type="text"
                                className="form-control"
                                value={supplierDetails.AddressType || ""}
                                placeholder="Enter pipncode"
                              />
                            </div>
                          </div>
                          <div className="col-md-12">
                            <div className="mb-0 input-blocks">
                              <label className="form-label">Address</label>
                              <textarea
                                className="form-control mb-1"
                                placeholder="Enter full address"
                                name="Supplier.AddressLine1"
                                value={supplierDetails.AddressLine1 || ""}
                              />
                              <p>Maximum 600 Characters</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex justify-content-end">
                      <button
                        type="button"
                        className="btn btn-cancel me-2"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /View Supplier */}
    </div>
  );
};

SupplierViewModal.propTypes = {
  supplierObj: PropTypes.object.isRequired,
};

export default SupplierViewModal;
